import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ReportStore } from '../../store/report-store';
import {
  ReportSortBy,
} from '../../../../models/report.model';
import { SortDirection } from '../../../../models/approval.model';

@Component({
  selector: 'que-reports-list-header',
  imports: [CommonModule, TranslateDirective, TranslatePipe],
  templateUrl: './reports-list-header.component.html',
  styleUrls: ['./reports-list-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportsListHeaderComponent {
  #reportStore = inject(ReportStore);

  readonly ReportSortBy = ReportSortBy;
  readonly SortDirection = SortDirection;

  @Input() sortBy: ReportSortBy = ReportSortBy.SentDate;
  @Input() sortDirection: SortDirection = SortDirection.Desc;

  @Output() sortChange = new EventEmitter<ReportSortBy>();
  requestSort(column: ReportSortBy): void {
    this.sortChange.emit(column);
  }

  handleSpaceKey(
    event: Event,
    column: ReportSortBy
  ): void {
    event.preventDefault();
    this.requestSort(column);
  }

  reports$ = toSignal(this.#reportStore.reports$);
  expandedIds$ = toSignal(this.#reportStore.expandedIds$);

  get isAllExpanded(): boolean {
    const reports = this.reports$()?.result ?? [];
    return reports.length > 0 && reports.every((r) => !!this.expandedIds$()?.[r.id]);
  }

  toggleExpandAll(): void {
    this.#reportStore.toggleExpandAll(this.reports$()?.result ?? []);
  }
}
